export const getProductReviews = async ids => {
  let reviews = null;
  // let formData = new FormData();
  // formData.append("products", JSON.stringify(ids));

  try {
    const response = await fetch(`/kiko/product-reviews?products=${encodeURI(JSON.stringify(ids))}`);
    reviews = await response.json();
  } catch (e) {
    console.log(e);
  }

  return reviews;
};
